import styled, { css } from 'styled-components';
import { ShipSmall } from 'ui-components/src/components/atoms/icons/ShipSmall';

export const MenuItem = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin: 8px 0;

  h3 {
    margin: 0 0 2px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`;

export const Label = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colors.textGrey};
  min-width: 65px;
`;

export const Content = styled.div`
  flex: 1;
  padding-left: 0.75rem;
`;

export const Text = styled.div`
  flex: 1;
`;

export const StyledShipIcon = styled(ShipSmall)`
  height: 50px;
  width: 50px;
`;
